import { Button, Modal, TextInput } from '@mantine/core';
import React, { useState } from 'react';
import { Box, Flex } from '../../../../components';
import { useAppSelector } from '../../../../hooks';
import { PropertiesFormI } from '../../../../types/common';
import { cloneObject } from '../../../../utils';

const TableModal = ({ onClose, onSubmit }: PropertiesFormI): JSX.Element => {
  const diagram = useAppSelector((state) => state.diagramR);
  const selectedTableData = cloneObject(diagram.selectedElement);
  const [tableName, setTableName] = useState(selectedTableData.data.name);

  const handleSubmitData = () => {
    selectedTableData.data.name = tableName;
    onSubmit(selectedTableData);
  };

  return (
    <Modal
      opened={diagram.showPropertiesForm}
      onClose={onClose}
      title="Table Properties"
      hideCloseButton
      size="md"
      transition="fade"
      transitionDuration={600}
      transitionTimingFunction="ease"
      centered
    >
      <Box px="16px">
        <TextInput
          size="md"
          value={tableName}
          onChange={(event) => setTableName(event.currentTarget.value)}
          label="Table Name"
          placeholder="Enter Table Name"
          required
        />

        <Flex justifyContent="center" mt="28px">
          <Button
            onClick={handleSubmitData}
            size="md"
            color="purple"
            disabled={tableName === ''}
          >
            Save
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};

export default TableModal;
